<template lang="pug">
  v-card.mt-3(flat)
    v-row.mx-2
      v-col
        h3 {{ $t('promotion') }}
    v-divider.mb-1
    div.promotion-container
      div.promotion-item(
        v-for='(item, i) in items'
        :key='i'
      )
        card-promotion(:item="item")

</template>
<script>   
import dialogAddVoucherSuccess from '@/views/Vouchers/childs/DialogAddVoucherSuccess'
import { vouchers as apiVouchers } from '@/apis'
import CardPromotion from '@/components/Promotion/CardPromotion'

export default {
  components:{
    dialogAddVoucherSuccess,
    CardPromotion
  },
  data: () => ({
    items: [],
    actionLoadding: false,
  }),
  async mounted () {
    await this.load ({'type': 'turnover'})
  },
  methods : { 
    async load (params = {}) {  
      const [,data,,] = await apiVouchers.list(params)

      this.items = data
    },
  }
}
</script> 
<style scoped>

.promotion-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 20px;
  padding-left: 4px;
  padding-right: 4px;
}

.header {
  font-size: 20px;
  color: white !important;
}

.sub-header {
  font-size: 20px;
  color: var(--btn-show-same-number-v2) !important;
}

.content-footer {
  margin-top: auto;
  padding-top: 10px;
}

#custom-disabled.v-btn--disabled.theme--light {
  background-color: var(--bg-main-color-3-v2) !important;
  opacity: 0.5;
  color: white !important;
}
#custom-disabled.v-btn--disabled.theme--dark {
  background-color: var(--btn-grey-2-v2) !important;
  opacity: 0.8;
  color: white !important;
}

@media only screen and (max-width: 799px) {
  .promotion-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

</style>